export const getCardWidth = container => {
  const slickSlide = container.querySelector('.slick-slide:not(.d-none)');
  return slickSlide && slickSlide.offsetWidth;
};

export const getParentWidth = (container, cardWidth) => {
  const slickList = container.querySelector('.slick-list');
  const parentWindowWidth = slickList && slickList.offsetWidth;
  return parentWindowWidth % cardWidth > 10 ? parentWindowWidth - cardWidth : parentWindowWidth;
};

export const handleScrollLeftPos = (container, updateCallback, fireTracking) => {
  const slickList = container.querySelector('.slick-list');
  const sliderWidth = slickList.offsetWidth;
  const scrollLeft = slickList.scrollLeft;
  const scrollWidth = slickList.scrollWidth;
  const prevBtn = container.querySelector('.left.carousel-control');
  const nextBtn = container.querySelector('.right.carousel-control');
  if (scrollLeft === 0) {
    prevBtn.classList.add('d-none');
  } else {
    prevBtn.classList.remove('d-none');
  }
  if (scrollWidth === sliderWidth + scrollLeft) {
    nextBtn.classList.add('d-none');
  } else {
    nextBtn.classList.remove('d-none');
  }
  updateCallback(scrollLeft, fireTracking);
};

export const collapseEmptyCarouselAdSlot = (container, adSlotClass, adActiveSlotIds) => {
  const activeIds = new Set(adActiveSlotIds);
  const adElements = container.querySelectorAll(adSlotClass);

  adElements.forEach(el => {
    const adSlotInElement = el.querySelector('.adBox[id]');
    const shouldShow = adSlotInElement && activeIds.has(adSlotInElement.id);
    el.classList.toggle('d-none', !shouldShow);
  });
};
